import {UniteDeMesureDTO} from "./unitedemesure-dto";

export class QuantiteDto {
  value: number;
  uniteDeMesure: UniteDeMesureDTO;
}
